import React from 'react';
import * as Routes from '@/modules/routes';
import NumberBadge from '@/components/shared/NewDashboard/Cards/NumberBadge';
import Callout from '../../../ProgramContents/Unit/Callout';
import DashboardCard from '../DashboardCard';
import { UnitType } from '../../types';

interface UnitCardProps {
  color: string;
  programId: number;
  unit: UnitType;
}

const UnitCard = ({ color, programId, unit }: UnitCardProps) => {
  const unitPath = Routes.shared_program_unit_path(programId, unit.id);

  return (
    <DashboardCard
      badge={unit.call_out_text ? (
        <Callout color={unit.call_out_color} text={unit.call_out_text} />
      ) : undefined}
      href={unitPath}
      imageUrl={unit.poster_url}
      numberLabel={(
        <NumberBadge color={color} location="unitCard" number={unit.display_number} />
      )}
      tag="li"
      title={unit.title}
    />
  );
};

export default UnitCard;
